import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "custom-icon-component" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'CustomSVG',
    props: {
        icon: {
            type: String,
            required: true,
        },
    },
    setup: function (__props) {
        var props = __props;
        var icon = "#icon-".concat(props.icon);
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
                _createElementVNode("use", {
                    "xlink:href": icon,
                    fill: "currentColor"
                })
            ]));
        };
    }
});
